import {
  CREATE_INCIDENT_REQUEST,
  FETCH_INCIDENT_BASICS_REQUEST,
  FETCH_INCIDENT_BASICS_RESPONSE,
  FETCH_INCIDENT_BY_ID_REQUEST,
  SAVE_INCIDENT_BASICS_REQUEST,
  SAVE_INCIDENT_BASICS_RESPONSE,
  SET_ACTIVE_INCIDENT_REQUEST,
  SET_ACTIVE_INCIDENT_RESPONSE,
  UPDATE_INCIDENT_BASICS_REQUEST,
  UPDATE_INCIDENT_BASICS_RESPONSE,
  UPDATE_REPORT_COMPONENT_REQUEST
} from '../constants/actionTypes';

export const initialState = {
  loading: false,
  list: [],
  incidentBasics: [],
  activeIncident: {}
};

const incidents = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_INCIDENT_BASICS_REQUEST:
    case UPDATE_INCIDENT_BASICS_REQUEST:
    case SET_ACTIVE_INCIDENT_REQUEST:
    case FETCH_INCIDENT_BY_ID_REQUEST:
    case SAVE_INCIDENT_BASICS_REQUEST:
    case UPDATE_REPORT_COMPONENT_REQUEST:
    case CREATE_INCIDENT_REQUEST:
      return {
        ...state,
        loading: true
      };

    case FETCH_INCIDENT_BASICS_RESPONSE:
      return {
        ...state,
        loading: false,
        incidentBasics: payload
      };

    case UPDATE_INCIDENT_BASICS_RESPONSE:
      let id = payload.id;
      delete payload.id;

      let activeIncident = {
        ...state.activeIncident,
        ...payload
      };

      const list = state.list.map(incident => {
        if (id === incident._id) return { ...activeIncident };
        return incident;
      });

      return {
        ...state,
        loading: false,
        activeIncident,
        list
      };

    case SET_ACTIVE_INCIDENT_RESPONSE:
      return {
        ...state,
        loading: false,
        activeIncident: payload
      };

    case SAVE_INCIDENT_BASICS_RESPONSE:
      return {
        ...state,
        loading: false
      };

    default:
      return {
        ...state
      };
  }
};

export default incidents;
